import { useEffect, useState } from 'react';

import { useThLoyaltyContext } from 'state/loyalty';
import { ILoyaltyTier } from 'state/loyalty/types';

export const useBankMyRewardsTierId = () => {
  // NOTE: this was a poorly named function, renaming here to be more explicity
  const { getLoyaltyTier: getBankMyRewardsTierId } = useThLoyaltyContext();

  const [bankMyRewardTierId, setBankMyRewardTierId] = useState<string | null>(null);

  useEffect(() => {
    getBankMyRewardsTierId().then((loyaltyTier: ILoyaltyTier) => {
      if (!loyaltyTier) {
        setBankMyRewardTierId(null);
        return;
      }

      setBankMyRewardTierId(loyaltyTier._id ?? null);
    });
  }, [getBankMyRewardsTierId, setBankMyRewardTierId]);

  return { bankMyRewardTierId };
};
